import MainTheme from "./index.vue";
import ThemeList from "./List.vue";
import ThemeEdition from "./Edition.vue";

export default {
  name: "MainTheme",
  path: "theme",
  redirect: "theme/list",
  component: MainTheme,
  meta: {
    label: "场景管理",
  },
  children: [
    {
      name: "ThemeList",
      path: "list",
      component: ThemeList,
      meta: {
        label: "场景列表",
      },
    },
    {
      name: "ThemeCreation",
      path: "edition",
      component: ThemeEdition,
      meta: {
        label: "创建场景",
      },
    },
    {
      name: "ThemeUpdation",
      path: "edition/:id",
      component: ThemeEdition,
      meta: {
        label: "编辑场景",
      },
    },
  ],
};
